module.exports = __webpack_public_path__ + "img/shuju.4cacc58e.svg";